/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CN from 'classnames';
import { Button, Input } from 'components/atoms';
import { Loader } from 'components/atoms/Loader';
import { useGetAllEnterprises } from 'framework/api/methods';
// import { ComplexDateRangePicker } from 'components/atoms/ComplexDateRangePicker';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDebounce from 'utils/debounce';

export interface EnterprisesProps {
  [x: string]: any;
}

export const Enterprises: FC<EnterprisesProps> = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [searchText, setSearchText] = useState('');
  const [enterprisesList, setEnterprisesList] = useState([]);

  const { mutate: getAllEnterprisesMutate, isLoading } = useGetAllEnterprises();

  const getAllEnterprises = () => {
    getAllEnterprisesMutate(
      {
        search: searchText === '' ? 'All' : searchText,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setEnterprisesList(successData?.enterprises || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setEnterprisesList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            // notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    getAllEnterprises();
  }, [debouncedSearchText]);

  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  const convertToLocalNumber = (phoneNumber: string) => {
    const str = String(phoneNumber);
    if (str.startsWith('94')) {
      return `0${str.slice(2)}`;
    }
    return `0${str}`;

    return str;
  };

  const formatDateDob = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  return (
    <div className="flex flex-col w-full h-full py-6 px-8">
      <div className="flex justify-between items-center">
        <div className="w-1/3 flex justify-start items-start">
          <div className="w-full">
            <Input
              icon="ri-search-line !text-[#C40D42] font-semibold"
              value={searchText}
              placeholder="Search here..."
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="w-2/3">
          <div className="flex justify-end items-end gap-x-2">
            <Button
              appearance="primary"
              onClick={() => {
                navigate('/enterprises/create');
              }}
            >
              <i className="ri-add-line pr-2" />
              Create
            </Button>
          </div>
        </div>
      </div>

      {isLoading && <Loader appearance="black" className="mt-5" />}

      {!isLoading && enterprisesList?.length === 0 && (
        <div className="mt-5 text-sm text-center w-full text-neutral-500">No enterprise found.</div>
      )}
      <div className="h-auto overflow-y-auto w-full mt-5 grid lg:grid-cols-4 grid-cols-2 gap-4  items-stretch">
        {!isLoading &&
          enterprisesList?.map((enterprise: any, index) => (
            <div
              className="bg-[#EFEFEF] h-full w-full flex flex-col justify-start rounded-[10px] py-5 px-3 cursor-pointer border-2 border-[#bfc2c3]"
              key={index}
              onClick={() => {
                navigate(`/enterprises/${enterprise.enterprise_id}`, { state: { enterpriseName: enterprise.enterprise_name },});
              }}
            >
              <div className="flex justify-end items-end w-full">
                <i
                  className="ri-edit-box-line text-[#C40D42] font-bold text-base leading-none cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation()
                    navigate(`/enterprises/update/${enterprise.enterprise_id}`, {
                      state: { enterprise },
                    });
                  }}
                />
              </div>
              <div className="text-xl font-semibold text-[#63717A] text-center">
                {enterprise.enterprise_name || `-`}
              </div>
              <div className="text-sm text-[#63717A] text-center">
                {formatDate(enterprise.created_at)}
              </div>

              <div className="bg-white rounded-[10px] p-4 w-full flex flex-col mt-5 text-xs text-[#63717A]">
                <div className="flex gap-x-1 justify-start items-center">
                  <i className="ri-map-pin-fill text-[#C40D42] text-base" />
                  <div className="pt-1 text-left">{enterprise.address || `-`}</div>
                </div>

                <div className="flex justify-between items-center mt-3 flex-wrap">
                  <div className="flex gap-x-1">
                    <i className="ri-phone-fill text-[#C40D42] text-base leading-none" />
                    <div>
                      {enterprise.phone_number
                        ? convertToLocalNumber(enterprise.phone_number)
                        : '-'}
                    </div>
                  </div>

                  <div className="flex gap-x-1">
                    <i className="ri-clipboard-fill text-[#C40D42] text-base leading-none" />
                    <div>{enterprise.br_number || `-`}</div>
                  </div>
                </div>
                <div className="flex gap-x-1 mt-3">
                  <i className="ri-mail-fill text-[#C40D42] text-base leading-none" />
                  <div className=" line-clamp-1 break-all">{enterprise.email || `-`}</div>
                </div>

                <div className='flex gap-x-3 mt-3 items-center' >
                  <div className="text-[#C40D42] font-semibold">Package</div>
                  <div className="bg-[#EFEFEF] px-2 py-[2px] rounded">{enterprise.package || `-`}</div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Enterprises;
